module.exports = __webpack_public_path__ + "img/2.513b57e1.jpg";